import { TextFieldProps, useTheme } from '@material-ui/core'
import { saveProjectReference } from 'features/BillOfMaterials/store/asyncActions/saveProjectReference'
import { ProjectTextField } from 'features/BillOfMaterials/store/components/ProjectTextField'
import { projectReferenceSelector } from 'features/BillOfMaterials/store/selectors/projectReferenceSelector'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { ProjectReferenceEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'

export function ProjectReferenceInput(props: {
  textFieldProps?: TextFieldProps
}) {
  const theme = useTheme()
  const { t } = useTranslation()
  const editable = useAppSelector(ProjectReferenceEditableStateSelector)

  const InputProps = {
    disableUnderline: true,
  }

  return (
    <ProjectTextField
      valueSelector={projectReferenceSelector}
      saveAction={saveProjectReference}
      textFieldProps={{
        title: t('project:project-reference'),
        placeholder: t('project:project-reference'),
        required: true,
        variant: 'standard',
        disabled: !editable,
        // eslint-disable-next-line
        InputProps: InputProps as any,
        inputProps: {
          style: {
            fontSize: theme.typography.h6.fontSize,
            padding: 0,
            fontWeight: theme.typography.fontWeightBold,
          },
          maxLength: 35,
        },
        ...props.textFieldProps,
      }}
    />
  )
}
